<template>
	<div
		class="modal fade"
		ref="modal"
		tabindex="-1"
		role="dialog"
		aria-hidden="true"
	>
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header modal-header-banner">
					<button
						type="button"
						class="modal-close"
						data-dismiss="modal"
						aria-label="Close"
					>
						<i class="sk-icon-times"></i>
					</button>
					<img src="/images/2k-delivery.png" alt="Delivery" />
				</div>
				<div class="modal-body">
					<div class="modal-title">Location is Key!</div>
					<div class="modal-subtitle">
						2ndKitchen needs access to your location to find nearby
						partners.
					</div>
					<button
						type="button"
						class="button button-primary"
						data-dismiss="modal"
						@click="confirm"
					>
						Ok
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-subtitle {
	font-size: 14px;
	color: var(--sk-grey3);
	margin-bottom: 20px;
}

.modal-body >>> .sk-input-wrapper {
	width: 100%;
}

.modal-body .button.button-primary {
	max-width: 335px;
}
</style>

<script>
export default {
	name: "GeolocationConfirmationModal",
	methods: {
		open() {
			$(this.$refs.modal).modal("show")
		},
		confirm() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Geolocation Modal Confirmed"
			})
			this.$emit("getLocation")
			this.close()
		},
		close() {
			$(this.$refs.modal).modal("hide")
		}
	}
}
</script>
